import { FC, useEffect, useState } from 'react';
import { Loader, MultiSelect, Text } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons';
import { fetchContactGroups } from '../../Service/restapi/contactGroupService';
import { ThemeText } from '../../Atoms/ThemeText';

interface Props {
  selectedGroups: string[];
  onChange: (groups: string[]) => unknown;
}

const ContactGroupsInput: FC<Props> = ({ selectedGroups, onChange }) => {
  const [allGroups, setAllGroups] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    fetchContactGroups()
      .then((resp) => {
        if (resp.ok) {
          resp.json().then((resJSON) => {
            if (resJSON) {
              setAllGroups(resJSON.map((g: any) => g.name));
            }
          });
        }
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <MultiSelect
      creatable
      searchable
      value={selectedGroups}
      onChange={onChange}
      label="Gruppen"
      icon={loading && <Loader size="xs" />}
      onCreate={(query) => {
        setAllGroups([...allGroups, query]);
        return query;
      }}
      getCreateLabel={(query) => (
        <Text color="blue">
          {' '}
          + Hinzufügen{' '}
          <ThemeText span color="black" ml={10} weight="bolder">
            {query}
          </ThemeText>
        </Text>
      )}
      styles={{ rightSection: { pointerEvents: 'none' } }}
      rightSection={<IconChevronDown size={14} />}
      rightSectionWidth={25}
      data={allGroups}
    />
  );
};

export default ContactGroupsInput;
